import { ContractAbi } from 'web3';
import { ContractAddress, Reward, RewardInfo } from '../../../shared/api/contract';

import { ConnectorType } from '@reown/appkit';
import { anyTokenSymbolAbi } from '../../../shared/api/contract/config';
import { MoonStaking } from '../../../shared/api/contract/ethers/moon-staking';
import { ethers } from 'ethers';

export class GetMainRewardService extends MoonStaking {
    constructor(contractAddress: ContractAddress, abi: ContractAbi, provider: ConnectorType, walletAddress: ContractAddress) {
        super(contractAddress, abi, provider, walletAddress);
    }

    async getMainReward( index: bigint): Promise<string> {
        try {
            const reward = (await this.contract.pendingRewardMain(this.walletAddress, index)) as bigint;

            return ethers.utils.formatEther(reward);
        } catch (error) {
            console.log(error);
            return '0';
        }
    }

    async getAllAdditionalRewardTokens(address: ContractAddress, depositIndex: bigint, lastRewardDeposit: number): Promise<Reward[]> {
        try {
            const lastRewardIndex = Number(await this.getAdditionalRewardLastIndex());

            if (lastRewardDeposit === lastRewardIndex) return [];

            let rewardIndexes: bigint[] = [];

            for (let i = lastRewardDeposit; i < lastRewardIndex; i++) {
                rewardIndexes.push(BigInt(i));
            }

            if (!rewardIndexes.length) return [];

            return await this.getRewards(address, depositIndex, rewardIndexes);
        } catch (error) {
            console.log(error);
            return [];
        }
    }

    private async getAdditionalRewardLastIndex(): Promise<number | undefined> {
        try {
            const index = (await this.contract.getAdditionalRewardLastIndex()) as number;

            return index;
        } catch (error) {
            console.log(error);
            return undefined;
        }
    }

    private async getRewardInfo(rewardIndex: bigint): Promise<RewardInfo | undefined> {
        try {
            const reawardInfo = (await this.contract.rewardInfo(rewardIndex)) as RewardInfo;

            return reawardInfo;
        } catch (error) {
            console.log(error);
            return undefined;
        }
    }

    private async pendingRewards(address: ContractAddress, depositIndex: bigint, rewardIndexes: bigint[]): Promise<bigint[]> {
        try {
            const rewardInfos = (await this.contract.pendingRewards(address, depositIndex, rewardIndexes)) as bigint[];
            console.log('rew', rewardInfos)
            return rewardInfos;
        } catch (error) {
            console.log(error);
            return [];
        }
    }

    private async getMoreInfoForReward(contractAddress: string): Promise<string> {
        try {
            const contract = new ethers.Contract(contractAddress, anyTokenSymbolAbi, this.signer);

            const symbol = (await contract.symbol()) as string;

            return symbol;
        } catch (error) {
            console.log(error);
            return '';
        }
    }

    private mergedRewards(rewards: Reward[]): Reward[] {
        const mergedData = Object.values(
            rewards.reduce((acc, { symbol, amount }) => {
                const am = BigInt(amount.toString());
                if (!acc[symbol]) {
                    acc[symbol] = { symbol, amount: 0n };
                }
                acc[symbol].amount += am;
                return acc;
            }, {} as Record<string, { symbol: string; amount: bigint }>)
        );

        return mergedData;
    }

    private async getRewards(address: ContractAddress, depositIndex: bigint, rewadIndexes: bigint[]): Promise<Reward[]> {
        try {
            const rewards = await this.pendingRewards(address, depositIndex, rewadIndexes);

            const result: Reward[] = [];

            const tasks = rewadIndexes.map(async (index, i) => {
                try {
                    const rewardInfo = await this.getRewardInfo(index);

                    if (!rewardInfo) return;

                    const rewardSymbol = await this.getMoreInfoForReward(rewardInfo.token);

                    result.push({ amount: rewards[i], symbol: rewardSymbol });
                } catch (error) {
                    console.log(error);
                }
            });

            await Promise.all(tasks);

            return this.mergedRewards(result);
        } catch (error) {
            console.log(error);
            return [];
        }
    }
}
